import { Engine } from './Engine'
import { GameEntity } from './GameEntity'
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer'

export class CSS2DRenderEngine implements GameEntity {
  readonly renderer: CSS2DRenderer

  constructor(private engine: Engine) {

    // 动态创建 CSS2DContainer
    this.renderer = new CSS2DRenderer()
    this.renderer.domElement.style.position = 'absolute'
    this.renderer.domElement.style.top = '0px';
    this.renderer.setSize(this.engine.canvas.width, this.engine.canvas.height)
    this.engine.canvas.parentElement?.appendChild(this.renderer.domElement)

  }

  update() {
    this.renderer.render(this.engine.scene, this.engine.camera.instance)
  }

  resize() {
    this.renderer.setSize(this.engine.sizes.width, this.engine.sizes.height)
  }
}
